/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from '@reduxjs/toolkit'
// eslint-disable-next-line max-len
import { getSuggestsQueryByMapClick } from 'feature/addresses/redux/actions/getSuggestsQueryByMapClick'
import { RootState } from 'store/types'

import { actions } from '../YandexMapSlice'

interface ThunkArg {
  e: any
}

// обрабатываем клик по карте
export const onClickMap = createAsyncThunk<
  void,
  ThunkArg,
  { state: RootState }
>('yandexMap/onClickMap', async ({ e }, { dispatch }) => {
  try {
    const YMap = window.map
    const zoom = YMap?.getZoom()

    if (!YMap) throw new Error('YMap instance is not available')
    const coords: [number, number] = e.get('coords')

    YMap.panTo(coords, { flying: true }).then(() => {
      const newZoom = zoom && zoom > 14 ? zoom : 14
      YMap.setCenter(coords, newZoom, { duration: 300 })
      setTimeout(() => {
        dispatch(actions.setClickMarkCoords(coords))
      }, 300)
    })

    // запрашиваем адрес по координатам для заполнения текстового поля,
    // метка остаётся на точке клика
    await dispatch(getSuggestsQueryByMapClick(coords))
  } catch (error) {
    console.error('yandexMap/onClickMap', error)
  }
})
